import type {
  ArchivedOperationalUser,
  ArchivedOperationalUserMatch,
  OperationalUser,
  OperationalUserCreateInput,
  OperationalUserDetails,
  OperationalUserUpdateInput,
} from "../domain";
import type {
  ArchivedOperationalUserDto,
  ArchivedOperationalUserMatchDto,
  OperationalUserCreateDto,
  OperationalUserDetailDto,
  OperationalUserDto,
  OperationalUserUpdateDto,
} from "./operationalUserDtos";

export function operationalUserFromDto(
  dto: OperationalUserDto,
): OperationalUser {
  return {
    id: dto.id,
    nameEn: dto.nameEn,
    nameAr: dto.nameAr,
    username: dto.username,
    email: dto.email,
    branch: dto.branch,
    department: dto.department ?? null,
    status: dto.status,
  };
}

export function operationalUserDetailsFromDto(
  dto: OperationalUserDetailDto,
): OperationalUserDetails {
  return {
    ...operationalUserFromDto(dto),
    mobileNumber1: dto.phoneNumber ?? null,
    permissions: dto.permissions ?? [],
  };
}

export function archivedOperationalUserFromDto(
  dto: ArchivedOperationalUserDto,
): ArchivedOperationalUser {
  return {
    id: dto.id,
    nameEn: dto.nameEn,
    nameAr: dto.nameAr,
    username: dto.username,
    email: dto.email,
    archivedAt: dto.archivedAt,
  };
}

export function operationalUserCreateToDto(
  input: OperationalUserCreateInput,
): OperationalUserCreateDto {
  return {
    nameEn: input.nameEn,
    nameAr: input.nameAr,
    username: input.username,
    email: input.email,
    ...(input.mobileNumber1 === undefined
      ? {}
      : { phoneNumber: input.mobileNumber1 }),
    branchId: input.branch.id,
    departmentId: input.department.id,
    permissions: [...input.permissions],
  };
}

export function operationalUserUpdateToDto(
  input: OperationalUserUpdateInput,
): OperationalUserUpdateDto {
  return {
    nameEn: input.nameEn,
    nameAr: input.nameAr,
    ...(input.mobileNumber1 === undefined
      ? {}
      : { phoneNumber: input.mobileNumber1 }),
    ...(input.status === undefined ? {} : { status: input.status }),
    branchId: input.branch.id,
    departmentId: input.department.id,
    permissions: [...input.permissions],
  };
}

// The 409 ARCHIVED_USER_FOUND match carries no archive date -- null until
// the backend sends one.
export function archivedOperationalUserMatchFromDto(
  dto: ArchivedOperationalUserMatchDto,
): ArchivedOperationalUserMatch {
  return {
    id: dto.id,
    nameEn: dto.nameEn ?? "",
    nameAr: dto.nameAr ?? "",
    archivedAt: null,
  };
}
